var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubscribeMap',{attrs:{"items":_vm.neighbourhoods,"api_url":_vm.$NEIGHBOURHOOD_API,"column_name":"location"},on:{"choose":_vm.choose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }